import React from 'react'
import styles from './index.module.css'
import PropTypes from 'prop-types'

const ConfirmationForm = ({ children, onSubmit, title, message }) => {
  return (
    <form className={styles.form} onSubmit={onSubmit}>
      <div className={styles.container}>
        <h1 className={styles.title}>{title}</h1>
        <div className={styles.message}>{message}</div>
        <div className={styles.actionsContainer}>{children}</div>
      </div>
    </form>
  )
}

ConfirmationForm.propTypes = {
  onSubmit: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  children: PropTypes.node,
}

export default ConfirmationForm
